var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrowico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.878,
    height: 12.89,
    viewBox: "0 0 13.878 12.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_back_4080892",
    transform: "translate(-1.543 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7810",
    "data-name": "Group 7810",
    transform: "translate(1.543 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M9.144,3.228a.679.679,0,0,1,0,.9l-.06.06L4.315,8.427H14.743a.678.678,0,0,1,.079,1.352l-.079,0H4.17l4.947,4.948a.679.679,0,0,1,.056.9l-.056.064a.679.679,0,0,1-.9.056l-.064-.056L1.543,9.077,8.186,3.171A.678.678,0,0,1,9.144,3.228Z",
    transform: "translate(-1.543 -3)",
    fill: "#203662"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowico);
export default __webpack_public_path__ + "static/media/backArrowico.f40b8813243ce5210582933a917ca6f7.svg";
export { ForwardRef as ReactComponent };